// ScrollLink.tsx
import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ScrollLinkView from './ScrollLinkView';
import { SCROLL_LINK_NODE_NAME } from './constants';

export const ScrollLink = Node.create({
  name: SCROLL_LINK_NODE_NAME,

  // The entire link is an atom (indivisible) with zero editable children
  inline: true,
  group: 'inline',
  content: '', // no child content-text lives in `attrs.message`
  atom: true,
  draggable: false, // (you can leave this or set to true if you want drag-and-drop)
  selectable: true, // so that the user can select the link as a whole

  addAttributes() {
    return {
      targetId: {
        default: null,
        parseHTML: (el) => el.getAttribute('data-target-id'),
        renderHTML: (attrs) => {
          if (!attrs.targetId) {
            return {};
          }
          return { 'data-target-id': attrs.targetId };
        },
      },
      // new `message` attribute to carry the link's visible text
      message: {
        default: '',
        parseHTML: (el) => el.textContent || '',
        // we do not need to emit any extra attribute in `renderHTML`-the text is appended as the node's content
        renderHTML: () => ({}),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-target-id]' }];
  },

  renderHTML({ HTMLAttributes, node }) {
    return ['span', mergeAttributes(HTMLAttributes, { class: 'import-warning' }), node.attrs.message];
  },

  // Use a ReactNodeView so we can intercept clicks and do our scroll
  addNodeView() {
    return ReactNodeViewRenderer(ScrollLinkView);
  },
});
